import { defineStore } from "pinia";
import { StoreModule } from "@/constants/store.ts";
import { AppContext } from "@/types.ts";

type AppsManagementState = {
  mspWorkspaceId: string;
  singleWorkspaceId: string;
  currentApplicationContext: AppContext;
};

const defaultAppsMgmtState: AppsManagementState = {
  mspWorkspaceId: "",
  singleWorkspaceId: "",
  currentApplicationContext: AppContext.SINGLE_WORKSPACE,
};
/**
 * This module is used to manage selected workspace in MSP and Regular Portal.
 */
export const useAppsManagementModule = defineStore(StoreModule.APPS_MGMT, {
  state: (): AppsManagementState => ({ ...defaultAppsMgmtState }),
  persist: true,
  getters: {
    context: (state) => state.currentApplicationContext,
    isMspContext: (state) => state.currentApplicationContext === AppContext.MSP,
    isSingleWorkspaceContext: (state) =>
      state.currentApplicationContext === AppContext.SINGLE_WORKSPACE,
  },
  actions: {
    setContext(context: AppContext) {
      this.currentApplicationContext = context;
    },
    handleAppsManagement(workspaceId: string, isMsp: boolean) {
      if (isMsp) {
        this.mspWorkspaceId = workspaceId;
      } else {
        this.singleWorkspaceId = workspaceId;
      }
    },
  },
});
